import * as Business               from '../business';
import * as ConversationsActions   from '../conversations/actions';
import * as ConversationsSelectors from '../conversations/selectors';
import * as User                   from '../user';
import { compose }                 from 'redux';
import { connect }                 from 'react-redux';
import FetchFromServer             from '../components/fetch_from_server';
import Navbar                      from '../components/navbar';
import React                       from 'react';
import restrictAccess              from '../components/restrict_access';


export default connect(
  (state, { businessID, conversationID }) => ({
    businessID,
    availableRoles: User.getAvailableRoles(),
    currentUserID:  User.getUserID(state),
    statuses:       [
      Business.getTeamStatuses(state, businessID),
      ConversationsSelectors.getConversationStatuses(state, conversationID)
    ],
    conversation: ConversationsSelectors.getConversation(state, conversationID),
    team:         Business.getTeam(state, businessID),
    isManager:    User.isManager(state, businessID)
  }),
  (dispatch, { businessID, conversationID, navigateBackTo }) => ({
    load: () => {
      dispatch(Business.readTeam(businessID));
      dispatch(ConversationsActions.readConversation(conversationID, businessID));
    },
    assignTeamMember: compose(dispatch, ConversationsActions.assignTeamMember),
    navigateBackTo
  })
)(restrictAccess(AssignPage, ({ isManager }) => isManager));


export function AssignPage({ currentUserID, conversationID, businessID, conversation, availableRoles, team, statuses, load, assignTeamMember, navigateBackTo }) {
  const [ customer ] = conversation?.customers ?? [];
  async function handleAssignTeamMember(e, user) {
    e.preventDefault();

    const userID = user?.id;
    await assignTeamMember({ conversationID, userID, businessID });
    navigateBackTo('../');
  }

  const assignees = conversation?.assignees ?? [];
  const title     = `Assign ${customer?.name?.full} To`;

  return (
    <React.Fragment>
      <Navbar title={title}/>
      <FetchFromServer statuses={statuses} load={load}>
        {team && (
          <TeamMembers
            team={team}
            assignees={assignees}
            currentUserID={currentUserID}
            availableRoles={availableRoles}
            handleAssignTeamMember={handleAssignTeamMember}
          />
        )}
      </FetchFromServer>
    </React.Fragment>
  );
}


function TeamMembers({ team, availableRoles, handleAssignTeamMember, assignees = [] }) {
  const users           = team?.users ?? [];
  const sortedUsers     = users.sort(alphabetical);
  const assigneeIDs     = assignees.map(a => a.user.id);
  const assignedUsers   = sortedUsers.filter(user => assigneeIDs.includes(user.id));
  const unassignedUsers = sortedUsers.filter(user => !assigneeIDs.includes(user.id));

  return (
    <div className="list media-list block">
      <ul>
        {assignedUsers.map(user => (
          <AssignedUser
            key={user.id}
            user={user}
            availableRoles={availableRoles}
            handleAssignTeamMember={handleAssignTeamMember}
          />
        ))}
        {unassignedUsers.map(user => (
          <UnassignedUser
            key={user.id}
            user={user}
            availableRoles={availableRoles}
            handleAssignTeamMember={handleAssignTeamMember}
          />
        ))}
      </ul>
    </div>
  );
}


function AssignedUser({ user, availableRoles, handleAssignTeamMember }) {
  return (
    <li>
      <a href="#" onClick={e => handleAssignTeamMember(e)} className="item-content">
        <label className="item-content no-fastclick item-radio">
          <input type="radio" name="callOption" value="browser" checked/>
          <i className="icon icon-radio"></i>
          <div className="item-inner">
            <div className="item-title">{user.name}</div>
            <div className="item-subtitle">{availableRoles[user.role]}</div>
          </div>
        </label>
      </a>
    </li>
  );
}


function UnassignedUser({ user, availableRoles, handleAssignTeamMember }) {
  return (
    <li>
      <a href="#" onClick={e => handleAssignTeamMember(e, user)} className="item-content">
        <div className="item-inner">
          <div className="item-title">{user.name}</div>
          <div className="item-subtitle">{availableRoles[user.role]}</div>
        </div>
      </a>
    </li>
  );
}


function alphabetical(a, b) {
  return a.name.localeCompare(b.name);
}
